module.exports = require('./helpers/bundle-url').getBundleURL('dAHXh') + "logo-dark.eefe0b7f.svg";